// extracted by mini-css-extract-plugin
export var chip = "_dy-0";
export var filterDropdown = "_dy-5";
export var filterItem = "_dy-6";
export var icon = "_dy-1";
export var removeButton = "_dy-3";
export var removeIcon = "_dy-4";
export var separator = "_dy-2";